/* HYTOVIA Cart-Upsell — ersetzt die App „Essential Upsell" (24.09.2026).
 *
 * Markup, Angebote und Prozentwerte: snippets/hv-cart-upsell.liquid (Drawer + /cart).
 * „Add" legt 1 Stück mit Property _upsell in den Warenkorb, setzt den Rabattcode des Produkts
 * und rendert Drawer bzw. Warenkorbseite neu — über dieselben Sections wie Dawns Mengenänderung.
 *
 * Ein Code gilt nur, solange das Upsell-Produkt im Warenkorb liegt UND daneben noch ein anderes
 * Produkt (Order Protection zählt nicht). Sonst nimmt das Skript ihn nach jeder Warenkorb-
 * Änderung wieder heraus. Fremde Codes (Influencer, Loox …) bleiben immer unangetastet.
 */
(function () {
  if (window.hvCartUpsell) return;
  window.hvCartUpsell = true;

  // Rabattcode → Produkt-Handle (muss zur Liste im Snippet passen)
  var CODE_HANDLE = {
    'ADDON-LIFTINGSTRAPS': 'lifting-straps',
    'ADDON-POSINGSCREEN': 'posingscreen',
    'ADDON-SPRINGPIN': 'spring-pin',
  };
  var IGNORE_HANDLE = 'order-protection';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var script = document.currentScript;

  function api(path, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(ROOT + path, opts).then(function (r) {
      return r.json();
    });
  }

  // Dawn-Komponenten auf der Seite: Drawer (cart-drawer-items) und Warenkorbseite (cart-items)
  function hosts() {
    return ['cart-drawer-items', 'cart-items']
      .map(function (s) {
        return document.querySelector(s);
      })
      .filter(function (h) {
        return h && typeof h.getSectionsToRender === 'function';
      });
  }

  function sectionIds() {
    var ids = [];
    hosts().forEach(function (h) {
      h.getSectionsToRender().forEach(function (s) {
        if (ids.indexOf(s.section) < 0) ids.push(s.section);
      });
    });
    return ids.slice(0, 5);
  }

  function render(state) {
    if (!state || !state.sections) return;
    hosts().forEach(function (host) {
      host.getSectionsToRender().forEach(function (s) {
        var html = state.sections[s.section];
        var box = document.getElementById(s.id);
        if (!html || !box) return;
        var el = box.querySelector(s.selector) || box;
        el.innerHTML = host.getSectionInnerHTML(html, s.selector);
      });
    });
  }

  function isValid(handle, handles) {
    return (
      handles.indexOf(handle) >= 0 &&
      handles.some(function (h) {
        return h !== handle && h !== IGNORE_HANDLE;
      })
    );
  }

  // Liste der Codes, die im Warenkorb stehen sollen (optional plus einen neuen)
  function wantedCodes(cart, add) {
    var handles = cart.items.map(function (i) {
      return i.handle;
    });
    var list = [];
    (cart.discount_codes || []).forEach(function (d) {
      var handle = CODE_HANDLE[String(d.code).toUpperCase()];
      if (!handle || isValid(handle, handles)) list.push(d.code);
    });
    if (add && CODE_HANDLE[add] && list.indexOf(add) < 0 && isValid(CODE_HANDLE[add], handles)) list.push(add);
    return list;
  }

  function applyCodes(codes) {
    return api('cart/update.js', {
      discount: codes.join(','),
      sections: sectionIds(),
      sections_url: window.location.pathname,
    });
  }

  function notify(state) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // source 'cart-items': Dawns CartItems rendern dann nicht noch einmal nach
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, hvUpsell: true });
    }
  }

  var cleaning = null;
  function cleanup() {
    if (cleaning) return cleaning;
    cleaning = api('cart.js')
      .then(function (cart) {
        var have = (cart.discount_codes || []).map(function (d) {
          return d.code;
        });
        var want = wantedCodes(cart);
        if (want.join(',') === have.join(',')) return;
        return applyCodes(want).then(function (state) {
          render(state);
          notify(state);
        });
      })
      .catch(function () {})
      .then(function () {
        cleaning = null;
      });
    return cleaning;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-hv-upsell-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-loading')) return;

    var card = btn.closest('[data-hv-upsell-card]');
    var select = card && card.querySelector('[data-hv-upsell-variant]');
    var id = Number(select ? select.value : btn.dataset.variant);
    var code = String(btn.dataset.code || '').toUpperCase();
    btn.classList.add('is-loading');

    api('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _upsell: 'Cart' } }] })
      .then(function (res) {
        if (res.status) throw res;
        return api('cart.js');
      })
      .then(function (cart) {
        return applyCodes(wantedCodes(cart, code));
      })
      .then(function (state) {
        render(state);
        notify(state);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (err && err.status === 422) {
          btn.setAttribute('aria-disabled', 'true');
          btn.lastElementChild.textContent = 'Sold out';
        }
      });
  });

  // Variante gewechselt (nur bei Produkten mit mehreren Varianten): Preise nachziehen
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-hv-upsell-variant]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var card = select.closest('[data-hv-upsell-card]');
    var now = card.querySelector('[data-hv-now]');
    var was = card.querySelector('[data-hv-was]');
    if (now) now.textContent = option.dataset.now;
    if (was) was.textContent = option.dataset.was;
  });

  // Nach jeder Warenkorb-Änderung (Menge, Entfernen, Hinzufügen) Codes prüfen
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!(event && event.hvUpsell)) setTimeout(cleanup, 250);
    });
  }
  if (script && Number(script.dataset.count) > 0) cleanup();
})();
